import { getAuth, signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth'
import { actionCodeSettings } from '../firebase/firebase'
import { formStates } from '../constants/helper-states'
import { upsertForm } from '../reducers/form'
import { removeAuth } from '../reducers/auth'
import { saveAuthHandler, saveAuthHandlerError } from '../reducers/auth-code'

const killState = () => {
    return {
        type: `KILL_STATE`
    }
}

export const saveAnonymousAuth = (auth) => {
    return {
        type: `SAVE_ANONYMOUS_AUTH`,
        auth
    }
}

export const clearAuthCode = () => {
    return {
        type: `REMOVE_AUTH_HANDLER`
    }
}

export const registerWithEmailAndPass = (fireauth, email, password, formId) => {
    return dispatch => {
        createUserWithEmailAndPassword(fireauth, email, password)
            .then(() => {
                dispatch(upsertForm({ id: formId, status: formStates.SUCCESS }))
            })
            .catch(err => {
                dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: `Error: ${err.message}` }))
            })
    }
}

export const signInWithEmailAndPass = (fireauth, email, password, formId) => {
    // console.log(fireauth)
    return dispatch => {
        signInWithEmailAndPassword(fireauth, email, password)
            .then(() => {
                dispatch(upsertForm({ id: formId, status: formStates.SUCCESS }))
            })
            .catch(err => {
                dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: `Error: ${err.message}` }))
            })
    }
}

export const generatePasswordResetLink = (fireauth, email, formId) => {
    return dispatch => {
        sendPasswordResetEmail(fireauth, email, actionCodeSettings)
            .then(() => {
                dispatch(upsertForm({ id: formId, status: formStates.SUCCESS }))
            })
            .catch(err => {
                console.log(err)
                dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: `Error: ${err.message}` }))
            })
    }
}

export const resetPasswordWithCode = (fireauth, code, email, password, formId) => {
    return dispatch => {
        return confirmPasswordReset(fireauth, code, password)
            .then((response) => {
                signInWithEmailAndPassword(fireauth, email, password)
                    .then(() => {
                        dispatch(upsertForm({ id: formId, status: formStates.SUCCESS }))
                    })
                    .catch(err => {
                        console.log('in here with an error?')
                    })
            })
            .catch(err => {
                dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: `Error: ${err.message}` }))
            })
    }
}

export const updateAuthPassword = (fireauth, formData, formId) => {
    return dispatch => {
        if (formData.newPassword !== formData.confirmPassword) {
            dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: 'New passwords do not match.' }))
            return false
        }
        const fireUser = fireauth.currentUser
        const credentials = fireauth.EmailAuthProvider.credential(fireUser.email, formData.existingPassword)
        return fireUser.reauthenticateWithCredential(credentials)
            .then(() => {
                fireUser.updatePassword(formData.newPassword)
                    .then(() => {
                        dispatch(upsertForm({ id: formId, status: formStates.SUCCESS }))
                    })
                    .catch(err => {
                        dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: `Error: ${err.message}` }))
                    })
            })
            .catch(err => {
                dispatch(upsertForm({ id: formId, status: formStates.ERROR, body: `Error: ${err.message}` }))
            })
    }
}

export const handleFirebaseAuthCode = (fireauth, code, action) => {
    return dispatch => {
        verifyPasswordResetCode(fireauth, code)
            .then(email => {
                dispatch(saveAuthHandler({ code, action, email, isAnonymous: false }))
            })
            .catch(err => {
                dispatch(saveAuthHandlerError())
                console.log('got an error...', err)
            })
    }
}

// export const handleFirebaseAuth = (firebaseUser) => {
//     return dispatch => {
//         dispatch(saveAuth(firebaseUser))
//     }
// }

export const handleSignOut = () => {
    return dispatch => {
        const auth = getAuth()
        signOut(auth)
            .then(() => {
                dispatch(removeAuth())
                dispatch(killState())
            })
            .catch(err => {
                console.log(err)
            })
    }
}
